export default __webpack_public_path__ + "static/media/home-startup-slider-bg-03.9977fc96.jpg";